module.exports = __webpack_public_path__ + "media/images/front/pc/collaboration/my_atopy_line/result-bg-1004454b42a9d5d4253025303dd6de85.svg";